import { QuestionPlanOnlyUseCreditPayment as Question } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/only-use-credit-payment";

import { useDayTripPlanOnlyUseCreditPayment } from "./hooks";

export const QuestionDayTripPlanOnlyUseCreditPayment = () => {
	const { onlyUseCreditPayment, onSetOnlyUseCreditPayment } = useDayTripPlanOnlyUseCreditPayment();

	return (
		<Question onSetOnlyUseCreditPayment={onSetOnlyUseCreditPayment} onlyUseCreditPayment={onlyUseCreditPayment} />
	);
};

QuestionDayTripPlanOnlyUseCreditPayment.displayName = "QuestionDayTripPlanOnlyUseCreditPayment";
